export class FinancePortalService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? FinancePortalService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${FinancePortalService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    async getPending() {
        const response = await this.http.get(this.buildUrl('pending'));
        return response.data ?? [];
    }
    async approve(id) {
        const response = await this.http.put(this.buildUrl(`${id}/approve`), {});
        return response.data;
    }
    async reject(id, reason) {
        const response = await this.http.put(this.buildUrl(`${id}/reject`), { reason });
        return response.data;
    }
    async hold(id, reason) {
        const response = await this.http.put(this.buildUrl(`${id}/hold`), { reason });
        return response.data;
    }
    async getHistory() {
        const response = await this.http.get(this.buildUrl('history'));
        return response.data ?? [];
    }
}
FinancePortalService.DEFAULT_SERVICE_PATH = 'procurements';
FinancePortalService.BASE_PATH = 'api/procurement-portal/finance';
//# sourceMappingURL=FinancePortalService.js.map